import { HttpClient } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ISignature } from './models/signature';
import { ITermsConditions } from './models/terms-conditions';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  localAppUrl = environment.localApiUrl;

  //Behavior Subject for Estimate
  private estimate = new BehaviorSubject('');
  getEstimate(): Observable<any> {
    return this.estimate.asObservable();
  }
  setEstimate(field) {
    this.estimate.next(field);
  }


  //Behavior Subject for Sales Orders
  private sales = new BehaviorSubject('');
  getSales(): Observable<any> {
    return this.sales.asObservable();
  }
  setSales(field) {
    this.sales.next(field);
  }

  //Behavior Subject for Invoice
  private invoice = new BehaviorSubject('');
  getInvoice(): Observable<any> {
    return this.invoice.asObservable();
  }
  setInvoice(field) {
    this.invoice.next(field);
  }

  //Behavior Subject for Receive Payments
  private receive = new BehaviorSubject('');
  getReceivePmt(): Observable<any> {
    return this.receive.asObservable();
  }
  setReceivePmt(field) {
    this.receive.next(field);
  }

  //Behavior Subject for Fullfill
  private fullfill = new BehaviorSubject('');

  getFullfill(): Observable<any> {
    return this.fullfill.asObservable();
  }

  setFullfill(fullfill) {
    this.fullfill.next(fullfill);
  }

  //Behavior Subject for Stage
  private stage = new BehaviorSubject('');

  getStage(): Observable<any> {
    return this.stage.asObservable();
  }

  setStage(stage) {
    this.stage.next(stage);
  }


  constructor(private http: HttpClient) { }

  getAllOrderStages() {
    return this.http.get<any>(this.localAppUrl + 'allOrderStages')
      .toPromise()
      .then(res => res);
  }
  editOrderStage(c) {
    return this.http.put<any>(this.localAppUrl + 'allOrderStages', c)
      .toPromise()
      .then(res => res);
  }

  getAllOrderTemplates() {
    return this.http.get<any>(this.localAppUrl + 'allOrderTemplates')
      .toPromise()
      .then(res => res);
  }
  editOrderTemplate(c) {
    return this.http.put<any>(this.localAppUrl + 'allOrderTemplates', c)
      .toPromise()
      .then(res => res);
  }

  getAllOrderStatus() {
    return this.http.get<any>(this.localAppUrl + 'allOrderStatus')
      .toPromise()
      .then(res => res);
  }

  getAllGroups(){
    return this.http.get<any>(`${environment.coreUrl}Group`)
  }

  getAllReturnData(groupId){
    return this.http.get<any>(`${environment.coreUrl}Type?groupId=${groupId}`);
  }

  setReasonTypeDefault(retunTypeId){
    return this.http.get<any>(`${environment.coreUrl}Type/SetDefault?id=${retunTypeId}`);
  }

  addReturnReason(data) {
    return this.http.post<any>(`${environment.coreUrl}Type`, data)
      .toPromise()
      .then(res => res);
  }

  updateReturnReason(data) {
    return this.http.put<any>(`${environment.coreUrl}Type`, data)
      .toPromise()
      .then(res => res);
  }

  checkDeleteStatus(id){
    return this.http.get<any>(`${environment.inventorySalesUrl}CustomerRma/CheckReasonOrderAssociation?reasonTypeId=${id}`)
  }

  deleteReturnReason(id) {
    return this.http.delete<any>(`${environment.coreUrl}Type/${id}`)
      .toPromise()
      .then(res => res);
  }

  getRMALocations() {
    return this.http.get<any>(`${environment.inventoryURl}WareHouse/ListRMAWarehouse`);
  }

  setRMALocDefault(warehouseId) {
    return this.http.put<any>(`${environment.inventoryURl}WareHouse/SetRMAWarehouse?warehouseId=${warehouseId}`,null);
  }

  getAllTypes() {
    return this.http.get<any>(`${environment.appOrgUrl}Type`)
  }

  getAllITermsConditions(): Observable<ITermsConditions[]> {
    return this.http.get<ITermsConditions[]>(`${environment.inventorySalesUrl}TermCondition`);
  }

  updateTermsConditions(data) {
    return this.http.put<ITermsConditions>(`${environment.inventorySalesUrl}TermCondition`, data);
  }

  saveTermsConditions(data) {
    return this.http.post<ITermsConditions>(`${environment.inventorySalesUrl}TermCondition`, data);
  }

  uploadFile(data): Observable<any> {
    return this.http.post<any>(environment.documentStorageUrl + 'UploadAttachmentToCloud', data);
  }

  saveSignature(data) {
    return this.http.post<any>(`${environment.inventorySalesUrl}Csig`, data);
  }

  updateSignature(data) {
    return this.http.put<any>(`${environment.inventorySalesUrl}Csig`, data);
  }

  getAllSignature(organizationId: number): Observable<ISignature[]> {
    return this.http.get<ISignature[]>(`${environment.inventorySalesUrl}Csig?OrganizationId=${organizationId}`);
  }

  getSignatureByObjectName(objName): Observable<any> {
    return this.http.get<any>(`${environment.inventorySalesUrl}Csig/Object?ObjectName=${objName}`);
  }

}
